import { ImageOff } from "lucide-react";

export function ProductImage({
  src,
  alt,
  className = "",
  eager = false,
}: {
  src?: string | null;
  alt: string;
  className?: string;
  eager?: boolean;
}) {
  if (!src) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-2 bg-secondary/50 text-muted-foreground ${className}`}
        role="img"
        aria-label={`${alt}, image coming soon`}
      >
        <ImageOff className="h-6 w-6 opacity-60" />
        <span className="text-[11px] font-medium uppercase tracking-wider">Image Coming Soon</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`object-contain ${className}`}
    />
  );
}
